import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-usuario-interno',
  templateUrl: './menu-usuario-interno.component.html',
  styleUrls: ['./menu-usuario-interno.component.scss']
})
export class MenuUsuarioInternoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
